import dayjs from 'dayjs';
import styles from './index.module.scss';

interface TrailModalProps {
	createdAt: string;
	city?: string;
	description: string;
}

export const TrailModal = (props: TrailModalProps) => {
	const { createdAt, city, description } = props;
	return (
		<div className={styles.modalDiv}>
			<div>
				<div>
					<h5>Date</h5>
					<p>{dayjs(createdAt).format('DD MMM, hh:mm A')}</p>
				</div>
				<div>
					<h5>City</h5>
					<p>{city}</p>
				</div>
			</div>
			<div>
				<h5>Status</h5>
				<p>{description}</p>
			</div>
		</div>
	);
};
